import React from 'react';
import Hero from './home/Hero';
import { TrustBar, FiveFlavours } from './home/TrustAndFlavours';
import Formula from './home/Formula';
import { Lifestyle, HowToUse, Personalities } from './home/Lifestyle';
import VideoSection from './home/VideoSection';
import Quiz from './home/Quiz';
import ReviewsStrip from './home/ReviewsStrip';
import MixBox from './home/MixBox';
import InstagramSection from './home/InstagramSection';
import { Purchase, FinalCta } from './home/Purchase';

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <FiveFlavours />
      <Formula />
      <Lifestyle />
      <VideoSection />
      <HowToUse />
      <Personalities />
      <Quiz />
      <ReviewsStrip />
      <InstagramSection />
      <MixBox />
      <Purchase />
      <FinalCta />
    </>
  );
}
